import { render } from "./ButtonWidget.vue?vue&type=template&id=81ff2ebc"
import script from "./ButtonWidget.vue?vue&type=script&lang=js"
export * from "./ButtonWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__